import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, ShoppingBag, MapPin, Home, ArrowLeft } from "lucide-react";
import { useApi } from "@/lib/api";
import { useMe } from "@/context/MeContext";

const Section = ({ to, icon: Icon, title, text, img, count, countLabel, dark, testId }) => (
  <Link to={to} data-testid={testId} className={`group relative overflow-hidden rounded-[2rem] p-8 sm:p-10 transition-transform duration-300 hover:-translate-y-1 ${dark ? "bg-[#0F382C] text-white" : "bg-white border border-[#E5DEC9]"}`}>
    <img src={img} alt="" className="absolute inset-0 h-full w-full object-cover opacity-10 transition-opacity group-hover:opacity-20" />
    <div className="relative">
      <Icon className={`h-10 w-10 ${dark ? "text-[#C59B27]" : "text-[#0F382C]"}`} />
      <h2 className="mt-6 text-2xl sm:text-3xl font-extrabold">{title}</h2>
      <p className={`mt-2 max-w-md ${dark ? "text-white/75" : "text-[#5C7067]"}`}>{text}</p>
      <div className="mt-8 flex items-center justify-between">
        <span className={`rounded-full px-4 py-1.5 text-sm font-semibold ${dark ? "bg-white/10" : "bg-[#F7F4EF] text-[#0F382C]"}`}>{count} {countLabel}</span>
        <ArrowLeft className="h-6 w-6 transition-transform group-hover:-translate-x-1" />
      </div>
    </div>
  </Link>
);

export default function OwnerHome() {
  const api = useApi();
  const { me } = useMe();
  const [ov, setOv] = useState(null);
  useEffect(() => {
    api("get", "/owner/overview").then(setOv).catch(() => {});
  }, [api]);
  return (
    <div data-testid="owner-home">
      <div className="mb-10 fade-up">
        <p className="text-sm text-[#5C7067]">أهلاً بك</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-[#0F382C]">{me.name}</h1>
        <div className="mt-3 flex flex-wrap gap-3 text-sm text-[#5C7067]">
          <span className="flex items-center gap-1" data-testid="owner-project-name"><MapPin className="h-4 w-4 text-[#C59B27]" />{me.project?.name} — {me.project?.city}</span>
          <span className="flex items-center gap-1" data-testid="owner-unit"><Home className="h-4 w-4 text-[#C59B27]" />{me.unit}</span>
        </div>
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <Section to="/owner/maintenance" icon={Wrench} title="خدمات الملاك" testId="owner-section-maintenance" img="/images/s_elev.jpg"
          text="صيانة المرافق المشتركة: المصاعد، إضاءة الممرات، السباكة العامة — مجانية ضمن العقد."
          count={ov?.open_maintenance ?? "–"} countLabel="بلاغ مفتوح" />
        <Section to="/owner/store" icon={ShoppingBag} title="الخدمات الشخصية" testId="owner-section-store" img="/images/faucet1.jpg" dark
          text="متجر منزلي للمنتجات مع خدمة التركيب داخل وحدتك والدفع عند التنفيذ."
          count={ov?.open_orders ?? "–"} countLabel="طلب جارٍ" />
      </div>
    </div>
  );
}
